import { Input } from "@/components/ui/input";
import { eur } from "@/lib/api";

export function TotalsCard({ items, transport, pct, locked, onTransport }) {
  const total = items.reduce((s, i) => s + (Number(i.price) || 0), 0);
  const share = (total * pct) / 100;
  return (
    <div className="rounded-2xl bg-[var(--ink)] text-white p-6 space-y-5 lg:sticky lg:top-6" data-testid="totals-card">
      <p className="text-xs uppercase tracking-[0.2em] text-[var(--primary)] font-semibold">Preventivo</p>
      <div>
        <p className="text-sm text-zinc-400">Totale oggetti ({items.length})</p>
        <p className="font-mono text-3xl font-bold" data-testid="items-total">{eur(total)}</p>
      </div>
      <div className="flex justify-between items-baseline border-t border-white/10 pt-4">
        <span className="text-sm text-zinc-300">Quota cliente {pct}%</span>
        <span className="font-mono text-xl font-semibold text-emerald-400" data-testid="client-share">{eur(share)}</span>
      </div>
      <div className="border-t border-white/10 pt-4 space-y-2">
        <label className="text-sm text-zinc-300">Spese di trasporto (a parte)</label>
        {locked
          ? <p className="font-mono text-lg" data-testid="transport-cost-value">{eur(transport)}</p>
          : <Input type="number" inputMode="decimal" min="0" step="0.5" value={transport} onChange={(e) => onTransport(e.target.value)}
              className="bg-white/10 border-white/20 text-white font-mono h-11" data-testid="transport-cost-input" />}
      </div>
    </div>
  );
}
